export default __webpack_public_path__ + "static/Icono_vertical_portada_libro-95e1d7fbecbc57ff2a20f94ec02da9f2.jpg";